<template>
    <div
        v-if="!is_renaming"
        @mouseleave="show_dropdown = false"
        :class="{'is-active': show_dropdown}"
        class="dropdown">

        <a @click="route_to" class="menu-item">
            <i v-if="saved_search.is_bookmarked" class="fas fa-thumbtack top-icon"></i>
            <i class="icon fas fa-filter"></i>
            {{saved_search.name}}

            <i v-if="space_permission('SEARCH_UPDATE') || space_permission('SEARCH_DELETE')"
                class="icon fas fa-ellipsis-v is-pulled-right"
                @click.prevent.stop="show_dropdown = !show_dropdown"></i>
        </a>

        <div class="dropdown-menu">
            <div class="dropdown-content">
                <a v-if="space_permission('SEARCH_UPDATE')" @click="edit" class="dropdown-item">
                    <i class="icon fas fa-wrench"></i> Edit
                </a>

                <a v-if="space_permission('SEARCH_UPDATE')" @click="show_rename" class="dropdown-item">
                    <i class="icon fas fa-pen"></i> Rename
                </a>

                <a v-if="space_permission('SEARCH_UPDATE')" @click="bookmark_search" class="dropdown-item">
                    <i class="icon fas fa-thumbtack"></i>
                    {{ saved_search.is_bookmarked ? 'Unpin' : 'Pin' }} filter
                </a>

                <a v-if="space_permission('SEARCH_DELETE')" @click="show_confirm = true" class="dropdown-item">
                    <i class="icon fas fa-trash-alt"></i> Delete
                </a>
            </div>
        </div>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to remove?"
            @close="show_confirm = false"
            @ok="remove_search"/>
    </div>

    <a v-else class="menu-item">
        <i class="icon fas fa-filter"></i>

        <input
            v-model="new_name"
            v-validate="'required'"
            @keyup.enter="rename"
            @blur="close_rename"
            class="menu-input"
            title="Name"
            name="name"
            ref="name"/>

        <i @click="rename" class="icon fas fa-check"></i>

        <span v-if="errors.has('name')" class="error">
            <br/>{{errors.first('name')}}
        </span>
    </a>
</template>

<script>
import { RELOAD_NOTES_LIST, Event } from '../../utils/events';

export default {
    name: 'SavedSearchItem',
    props: ['space', 'saved_search'],
    data() {
        return {
            show_dropdown: false,
            show_confirm: false,
            is_renaming: false,
            new_name: '',
        };
    },
    methods: {
        route_to() {
            if (this.$route.query.saved_search_id === this.saved_search.id) {
                Event.$emit(RELOAD_NOTES_LIST);
                return;
            }

            this.$router.push({
                name: 'content',
                query: {
                    saved_search: this.saved_search.name,
                    saved_search_id: this.saved_search.id,
                    name_contains: this.saved_search.name_contains,
                    content_contains: this.saved_search.content_contains,
                    authors: this.saved_search.authors.map(obj => obj.id),
                    topics: this.saved_search.topics.map(obj => obj.id),
                    or_tags: this.saved_search.or_tags || undefined,
                    tags: this.saved_search.tags.map(obj => obj.id),
                },
            });
        },
        async bookmark_search() {
            await this.$store.dispatch('saved_searches/update', {
                space_id: this.space.id,
                saved_search_id: this.saved_search.id,
                data: { is_bookmarked: !this.saved_search.is_bookmarked },
                patch: true,
            });

            this.$store.commit('saved_searches/bookmark', { id: this.saved_search.id });
        },
        remove_search() {
            this.$store.dispatch('saved_searches/remove', {
                saved_search_id: this.saved_search.id,
                space_id: this.space.id,
            }).then(() => {
                this.$store.dispatch('saved_searches/list', { space_id: this.space.id });
            });
        },
        edit() {
            this.$emit('edit', this.saved_search);
            this.show_dropdown = false;
        },
        show_rename() {
            this.new_name = this.saved_search.name;
            this.show_dropdown = false;
            this.is_renaming = true;
            this.$nextTick(() => this.$refs.name.focus());
        },
        close_rename() {
            if (this.new_name === this.saved_search.name) {
                this.is_renaming = false;
                this.new_name = '';
            }
        },
        async rename() {
            await this.$store.dispatch('saved_searches/update', {
                space_id: this.space.id,
                saved_search_id: this.saved_search.id,
                data: { name: this.new_name },
                patch: true,
            });

            this.$store.commit('saved_searches/rename', { id: this.saved_search.id, name: this.new_name });
            this.is_renaming = false;
            this.new_name = '';
        },
    },
};
</script>

<style scoped>
    .menu-item .fa-ellipsis-v {
        display: none;
        position: absolute;
        right: 0;
    }

    .menu-item:hover .fa-ellipsis-v {
        display: -ms-inline-flexbox;
        display: inline-flex;
    }
</style>
